import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./SideBar.css";
import $ from "jquery";

export default function SideBar(props) {
  $(document).ready(function () {
    if (props.active === "Welcome") {
      $(".sidebar")
        .find(".text-danger")
        .addClass("text-light")
        .removeClass("text-danger");
      $(".sidebar #welcome").addClass("text-danger").removeClass("text-light");
    } else if (props.active === "About") {
      $(".sidebar")
        .find(".text-danger")
        .addClass("text-light")
        .removeClass("text-danger");
      $(".sidebar #about").addClass("text-danger").removeClass("text-light");
    } else if (props.active === "Projects") {
      $(".sidebar")
        .find(".text-danger")
        .addClass("text-light")
        .removeClass("text-danger");
      $(".sidebar #projects").addClass("text-danger").removeClass("text-light");
    } else if (props.active === "Certifications") {
      $(".sidebar")
        .find(".text-danger")
        .addClass("text-light")
        .removeClass("text-danger");
      $(".sidebar #certifications")
        .addClass("text-danger")
        .removeClass("text-light");
    }
  });
  return (
    <>
      <Nav className="sidebar">
        <Link className="text-light p-3" id="welcome" to="/">
          Welcome
        </Link>
        <Link className="text-light p-3" id="about" to="/about">
          About
        </Link>
        <Link className="text-light p-3" id="projects" to="/projects">
          Projects
        </Link>
        <Link
          className="text-light p-3"
          id="certifications"
          to="/certifications"
        >
          Certifications
        </Link>
      </Nav>
    </>
  );
}
